import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jujue",
  "use": "icon-jujue-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jujue\"><path d=\"M804.32535 762.982L314.18735 181.331c159.283-95.545 368.804-64.251 492.378 82.426 123.575 146.612 118.967 358.436-2.24 499.225m-586.963-2.687c-123.575-146.613-118.903-358.501 2.24-499.29L709.73935 842.656c-159.283 95.545-368.803 64.251-492.378-82.361m-35.325-639.76C-34.13865 302.73-61.72065 625.65 120.47335 841.888c182.195 216.24 505.178 243.758 721.417 61.564 216.176-182.13 243.758-505.114 61.564-721.353C721.25935-34.141 398.27635-61.66 182.03735 120.535\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jujue.svg
// module id = 2qqc
// module chunks = 12